import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'
import store from '../store'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const demoRoutes = []
if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_INCLUDE_DEMOS) {
  const vueBookRoutes = require('./vueBookRoutes').default
  vueBookRoutes.forEach(route => demoRoutes.push(route))
}

// export default new Router({
let router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  mode: 'history',
  routes: [
    ...demoRoutes,
    {
      path: '/',
      redirect: { name: 'dashboard' },

    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: '/login',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          name: 'signup',
          path: '/signup',
          component: () => import('../components/auth/signup/Signup.vue'),
        },

        {
          name: 'recover-password',
          path: 'recover-password',
          component: () => import('../components/auth/recover-password/RecoverPassword.vue'),
        },
      ],
    },

    {
      name: 'Privacy Policy',
      path: '/privacypolicy',
      component: EmptyParentComponent,
      children: [
        {
          name: '',
          path: '',
          component: () => import('../components/auth/privacyPolicy/privacy.vue'),
        },
      ],
    },
    {
      name: 'SupportPage',
      path: '/supportPage',
      component: EmptyParentComponent,
      children: [
        {
          name: '',
          path: '',
          component: () => import('../components/auth/SupportPage/supportPage.vue'),
        },
      ],
    },

    // {
    //   name: 'Privacy Policy',
    //   path: '/privacypolicy',
    //   component: () => import('../components/auth/privacyPolicy/privacy.vue'),
    // },

    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: '/dashboard',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },
        // .......................Common...............................
        {
          name: 'changepassword',
          path: '/changepassword',
          component: () => import('../components/Common/changepassword.vue'),
          meta: {
            requiresAuth: true,
          },
        },

        // ..........................Elements................................
        {
          name: 'classification',
          path: '/classification',
          component: () => import('../components/Elements/classification.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },
        // {
        //   name: 'conservStat',
        //   path: '/conservStat',
        //   component: () => import('../components/conservStat.vue'),
        //   default: true,
        //   meta: {
        //     requiresAuth: true,
        //   },
        // },
        {
          name: 'editclassification',
          path: '/editclassification/:id',
          component: () => import('../components/Elements/editclassification.vue'),
          meta: {
            requiresAuth: true,
          },
          props: true,
        },

        {
          name: 'conservStatedit',
          path: '/conservStatedit/:id',
          component: () => import('../components/Elements/conservStatedit.vue'),
          meta: {
            requiresAuth: true,
          },
          props: true,
        },
        {
          name: 'wlpa',
          path: '/wlpa',
          component: () => import('../components/Elements/wlpa.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },

        {
          name: 'cites',
          path: '/cites',
          component: () => import('../components/Elements/cites.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'editcites',
          path: '/editcites/:id',
          component: () => import('../components/Elements/editcites.vue'),
          meta: {
            requiresAuth: true,
          },
          props: true,
        },
        {
          name: 'editwlpa',
          path: '/editwlpa/:id',
          component: () => import('../components/Elements/editwlpa.vue'),
          meta: {
            requiresAuth: true,
          },
          props: true,
        },

        {
          name: 'crimetypes',
          path: '/crimetypes',
          component: () => import('../components/Elements/crimetypes.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'sources',
          path: '/sources',
          component: () => import('../components/Elements/sources.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'editcrimetype',
          path: '/editcrimetype/:id',
          component: () => import('../components/Elements/editcrimetype.vue'),
          meta: {
            requiresAuth: true,
          },
          props: true,
        },

        {
          name: 'sourceedit',
          path: '/sourceedit/:id',
          component: () => import('../components/Elements/sourceedit.vue'),
          meta: {
            requiresAuth: true,
          },
          props: true,
        },

        {
          name: 'usertype',
          path: '/usertype',
          component: () => import('../components/Elements/usertype.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'editusertype',
          path: '/editusertype/:id',
          component: () => import('../components/Elements/editusertype.vue'),
          meta: {
            requiresAuth: true,
          },
          props: true,
        },
        {
          name: 'avatars',
          path: '/settingAvatars',
          component: () => import('../components/Elements/avatars.vue'),
          default: true,
          meta: {
            requiresAuth: true,
          },
        },
        // .............................Crim Reports......................................
        {
          name: 'crimeReports',
          path: 'crimeReports',
          component: EmptyParentComponent,
          children: [
            {
              name: 'reportsview',
              path: '/reportsview/:id',
              component: () => import('../components/CrimeReports/reportsview.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'report-crime',
              path: '/report-crime',
              component: () => import('../components/CrimeReports/ReportCrime.vue'),
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'reportslist',
              path: '/reportslist/:type',
              component: () => import('../components/CrimeReports/reportslist.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
            {
              name: 'allreportslist',
              path: '/allreportslist/:type',
              component: () => import('../components/CrimeReports/reportslist.vue'),
              meta: {
                requiresAuth: true,
              },
              props: route => ({ type: route.params.type, showAll: true }),
            },
            {
              name: 'singlereportlist',
              path: '/singlereportlist',
              component: () => import('../components/CrimeReports/singlereportlist.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'pendingcr',
              path: '/pendingcr',
              component: () => import('../components/CrimeReports/pendingcr.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
            {
              name: 'analytics',
              path: '/analytics',
              component: () => import('../components/CrimeReports/analytics.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
          ],
        },

        // .............................Excel Reports......................................
        {
          name: 'ExcelReports',
          path: 'ExcelReports',
          component: EmptyParentComponent,
          children: [
            {
              name: 'speciesSchedule',
              path: '/speciesSchedule',
              component: () => import('../components/ExcelReports/speciesSchedule.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },

          ],
        },

        // ......................................Identification Guide..............................
        {
          name: 'identificationGuide',
          path: 'guideList',
          component: EmptyParentComponent,
          children: [
            {
              name: 'guideList',
              path: '/guideList',
              component: () => import('../components/IdentificationGuide/guideList.vue'),
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'guideView',
              path: '/guideView/:id',
              component: () => import('../components/IdentificationGuide/guideView.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
            {
              name: 'viewqueries',
              path: '/viewqueries/:id',
              component: () => import('../components/Queries/viewqueries.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },

          ],
        },

        // ......................................Queries..............................
        {
          name: 'queries',
          path: 'queries',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listqueries',
              path: '/listqueries',
              component: () => import('../components/Queries/listqueries.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'viewqueries',
              path: '/viewqueries/:id',
              component: () => import('../components/Queries/viewqueries.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
            {
              name: 'replyquery',
              path: '//:id',
              component: () => import('../components/Queries/viewqueries.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
          ],
        },
        // ......................................Enqueries..............................

        {
          name: 'customenquiry',
          path: '/customenquiry',
          component: EmptyParentComponent,
          children: [
            {
              name: 'enquirylist',
              path: '/enquirylist',
              component: () => import('../components/Enquiries/enquirylist.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'enquiryview',
              path: '/enquiryview/:id',
              component: () => import('../components/Enquiries/enquiryview.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },

          ],
        },

        // ......................................Digital Guide..............................

        {
          name: 'digitalguide',
          path: 'digitalguide',
          component: EmptyParentComponent,
          children: [
            {
              name: 'addRecords',
              path: '/addRecords',
              component: () => import('../components/DigitalGuide/addRecords.vue'),
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'recordDetails',
              path: '/recordDetails/:id',
              component: () => import('../components/DigitalGuide/recordDetails.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'listRecords',
              path: '/listRecords',
              component: () => import('../components/DigitalGuide/listRecords.vue'),
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'editRecords',
              path: '/editRecords/:id',
              component: () => import('../components/DigitalGuide/editRecords.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'adddigi',
              path: '/adddigi/:id',
              component: () => import('../components/DigitalGuide/adddigi.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'editdigi',
              path: '/editdigi/:id',
              component: () => import('../components/DigitalGuide/editdigi.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },

          ],
        },

        // ......................................Analytics..............................

        {
          name: 'analytics',
          path: '/analytics',
          component: EmptyParentComponent,
          children: [
            {
              name: 'Crimereportanalytics',
              path: '/Crimereportanalytics',
              component: () => import('../components/Analytics/Crimereportanalytics.vue'),
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },

        // ......................................Useers..............................

        {
          name: 'UserDetails',
          path: '/UserDetails',
          component: EmptyParentComponent,
          children: [

            {
              path: '/userview/:id',
              name: '/userview',
              component: () => import('../components/Users/userview.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'users',
              path: '/users/:type',
              component: () => import('../components/Users/users.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
            {
              name: 'userMap',
              path: '/usermap',
              component: () => import('../components/Users/userMap.vue'),
              meta: {
                requiresAuth: true,
              },
            },

          ],
        },
        {
          name: 'AnalystDetails',
          path: '/analysts',
          component: EmptyParentComponent,
          children: [

            {
              path: '',
              name: 'analysts',
              component: () => import('../components/Analysts/analysts.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'addAnalyst',
              path: 'add',
              component: () => import('../components/Analysts/addAnalyst.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
          ],
        },

        {
          name: 'OffenderDetails',
          path: '/offenders',
          component: EmptyParentComponent,
          children: [
            {
              path: '',
              name: 'offenders',
              component: () => import('../components/Offenders/offenders.vue'),
              props: true,
              meta: {
                requiresAuth: true,
              },
            },
            {
              name: 'addOffender',
              path: 'add',
              component: () => import('../components/Offenders/addOffender.vue'),
              meta: {
                requiresAuth: true,
              },
              props: true,
            },
          ],
        },

        {
          name: 'offenderDetails',
          path: '/offender-details',
          component: () => import('../components/Offenders/offenderDetails.vue'),
          meta: {
            requiresAuth: true,
          },
        },

        {
          name: 'editOffender',
          path: '/edit-offender',
          component: () => import('../components/Offenders/addOffender.vue'),
          meta: {
            requiresAuth: true,
          },
        },

        {
          name: 'pages',
          path: 'pages',
          component: EmptyParentComponent,
          children: [
            {
              name: '404-pages',
              path: '404-pages',
              component: () => import('../components/pages/404-pages/404PagesPage'),
            },
          ],
        },
      ],
    },

  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.name && store.state.isLoggedIn)) {
    axios({
      method: 'POST',
      url: '/authenticate/',
      headers: {
        token: localStorage.getItem('token'),
      },
    }).then(response => {
      if (response.data.expired) {
        store.commit('logoutUser', true)
        next({
          path: '/login',
        })
      }
    })
      .catch(e => {
        var err

        alert('No Network Found!! please do a refresh ')
        err.push(e)
        window.location.reload()
      })
  }
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    next({ name: 'login' })
    return
  }
  if (to.path === '/auth/login' && store.state.isLoggedIn) {
    next({ name: 'dashboard' })
    return
  }
  if (to.path === '/login' && store.state.isLoggedIn) {
    next({ name: 'dashboard' })
    return
  }

  next()
})

export default router
